import { HTTPClient } from "@/utils/request.api";

export default {
  ConsultaParceiro: ({ payload }) =>
    HTTPClient.post("ConsultaParceiro", payload),
  ConsultarViabilidade: ({ payload }) =>
    HTTPClient.post("ConsultarViabilidade", payload),
  SemViabilidade: ({ payload }) => HTTPClient.post("SemViabilidade", payload),
  DadosPessoais: ({ payload }) => HTTPClient.post("DadosPessoais", payload),
  Endereco: ({ payload }) => HTTPClient.post("Endereco", payload),
  Fatura: ({ payload }) => HTTPClient.post("Fatura", payload),
  Biometria: (orderId, formData) =>
    HTTPClient.post(`/Biometria/${orderId}`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }),
  ComplementarDados: ({ payload }) =>
    HTTPClient.post("ComplementarDados", payload),
  AtualizarProduto: ({ payload }) =>
    HTTPClient.post("AtualizarProduto", payload),
  AdicionarSVA: ({ payload }) => HTTPClient.post("AdicionarSVA", payload),
  Lead: ({ payload }) => HTTPClient.post("Lead", payload),
  Retomada: ({ payload }) => HTTPClient.get(`Retomada?${payload}`),
};
